export const extractRolesFromToken = (token) => {
  try {
    if (!token) return [];

    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.userId?.role || [];
  } catch (err) {
    console.error("Token role extraction failed", err);
    return [];
  }
};
